import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(rootSaga);

import { all, fork } from 'redux-saga/effects';
import watchGetUserDetails from './userDetails/getDetails';
import watchGetLocalItems from './localList/getItems';
import { watchAddLocalItems, watchRemoveLocalItems, watchUndoLocalItems } from './localList/updateItems';
import watchGetGlobalItems from './globalList/getItems';
import { watchAddGlobalItems, watchRemoveGlobalItems, watchUndoGlobalItems } from './globalList/updateItems';
export var sagas = [fork(watchGetUserDetails), fork(watchGetLocalItems), fork(watchAddLocalItems), fork(watchRemoveLocalItems), fork(watchUndoLocalItems), fork(watchGetGlobalItems), fork(watchAddGlobalItems), fork(watchRemoveGlobalItems), fork(watchUndoGlobalItems)];
export default function rootSaga() {
  return _regeneratorRuntime.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all(sagas);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}